import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { Link } from '@router/Link';
import { pressActionEffect } from '@styles/mixin';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import useRecentOrders from './hooks/useRecentOrders';
import RecentOrderItem from './RecentOrderItem';

function RecentOrders() {
    const recentOrders = useRecentOrders();
    const { t } = useTranslation('main', { keyPrefix: 'recentOrders' });
    if (recentOrders && recentOrders.length > 0) {
        return (
            <div>
                <Row fullWidth justify='space-between'
                    css={css`margin: 20px 0 16px; padding: 0 20px;`} >
                    <Text color={colors.gray8}
                        size='lg'
                        fontWeight='bold' >
                        {t('title')}
                    </Text>
                    <Link activityName='OrderLogsActivity'
                        activityParams={{ duration: 'WEEK' }}>
                        <Row css={pressActionEffect}>
                            <Text color={colors.gray6} size='s'>
                                {t('showAll')}
                            </Text>
                            <ArrowLineRight size={18}/>
                        </Row>
                    </Link>
                </Row>
                <Contents>
                    {recentOrders?.map((order) => (
                        <RecentOrderItem order={order}
                            key={order.orderId} />
                    ))}
                </Contents>
            </div>
        );
    }
    return (<Fragment/>);
}

const Contents = styled.div`
    padding-bottom: 48px;
    overflow-y: auto;
    padding-left: 20px;
    scroll-snap-type: x mandatory;
    width: 100vw;
    display: flex;
    column-gap: 8px;
    scroll-padding: 0 20px;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export default RecentOrders;
